import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { ApplicationKey, tUser, tVEwithDetailedResources, tAssetType, tProductType, tDevicesStatusReport, tDevicesStatusReportByState, tDeviceCapability, tFunctionalGroupListing, tFunctionalGroup, tFunctionalGroupAccount, tFunctionalGroupAccountReq, tDirectory, tDirectoryType, tWiFiAccessPointInfo, tDeviceWithSetting, tLoginEvent, tMPXNInventory, tMPXNInventoryWithWarnings, tEligibitySmetsFuelTypesReq, tVerificationInfoSubmission } from './glowadmin.typings';
import { tAssetRawPackets, tAssetStatus } from './glowadmin.typings';
import { tAlertHistoryUser, tDeviceType, tDevice, tDeviceStatus, tDeviceLastReading, tDeviceRawPackets, tGroup, tGroupAccount, tInternalUser } from './glowadmin.typings';
import { tVE, tVEType, tResource, tResourceType, tDiscoveryInfo, tDeviceProductDiscovery } from './glowadmin.typings';
import {
    tAccount, tAccountStats, tApplication, tTemporaryAccessCredentials, tOrganization,
    Log, tTrafficTimeSeries, tTemplate, tAlertStatus, tAlertType, tStatusIsOk, tMPXNHealthCheck
} from './glowadmin.typings';
import { Observable } from 'rxjs/Rx';

// seperate tApplication definition into an applications.ts file instead of in component

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import { ConfigService } from '../app-config.service';

export class AdminHeadersGlow extends Headers {

    constructor() {
        super();
        this.append('X-GLOW-Version', '0');
        this.append('Content-type', 'application/json');
        this.append('token', localStorage.getItem('id_token'));
    }
}

export class AppHeadersGlow extends Headers {

    constructor(appKey: ApplicationKey) {
        super();
        this.append('X-GLOW-Version', '0');
        this.append('Content-type', 'application/json');
        this.append('Authorization', 'Basic ' + btoa(appKey.appKey + ':' + appKey.appSecretKey));
        console.log('Basic ' + btoa(appKey.appKey + ':' + appKey.appSecretKey));
    }

    // Make sure to instance this with an appToken that is created by the App

}

export class AppIdHeadersGlow extends Headers {

    constructor(appId: string) {
        super();
        this.append('X-GLOW-Version', '0');
        this.append('Content-type', 'application/json');
        this.append('token', localStorage.getItem('id_token'));
        this.append('applicationId', appId);
        console.log('AppIdHeaders ' + appId);
    }

    // Make sure to instance this with an appToken that is created by the App

}

export class AppIdUserIdHeadersGlow extends Headers {

    constructor(appId: string, userId: string) {
        super();
        this.append('X-GLOW-Version', '0');
        this.append('Content-type', 'application/json');
        this.append('token', localStorage.getItem('id_token'));
        this.append('applicationId', appId);
        this.append('userId', userId);

        console.log('AppIdUserIdHeadersGlow ' + appId);
    }

    // Make sure to instance this with an appToken that is created by the App

}

@Injectable()
export class GlowAdminService {

    private hostUrl;
    private rateLimitingHostUrl;

    constructor(
        private configService: ConfigService,
        private http: Http) {
        let configuration = this.configService.loadAdminConfig();
        this.hostUrl = configuration.environment.baseEndpoint;
        this.rateLimitingHostUrl = configuration.environment.rateLimitingHostUrl;

    }

    //********************** User/Internal user etc *************************/

    getAccounts(appId: string): Observable<tAccount[]> {

        console.log('Get accounts ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'account/summary-list', { headers: appIdHeaders })
            .map((res: any) => {
                let accounts = res.json();
                return accounts;
            });
    }

    getAccount(appId: string, id: string): Observable<tAccount> {

        console.log('Get account ' + id);
        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'account/' + id, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    addAccount({ applicationId, userId, username }): Observable<tAccount> {

        const appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        const body = { ...username && { username }, ...userId && { userId } };
        return this.http.post(this.hostUrl + 'account/', body, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    updateAccount(appId: string, accountId: string, updateBody): Observable<tAccount> {
        console.log('Update an account');
        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);
        return this.http.put(this.hostUrl + 'account/' + accountId, JSON.stringify(updateBody), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getInternalUsers(): Observable<[tInternalUser]> {

        console.log('Get internal Users');
        let devHeaders: Headers = new AdminHeadersGlow();

        return this.http
            .get(this.hostUrl + 'internaluser/', { headers: devHeaders })
            .map((res: any) => {
                let internlUserGroup = res.json();
                return internlUserGroup;
            });
    }

    getUser(appId: string, id: string): Observable<tUser> {

        console.log('Get an user');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'user/' + id, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    getUserByUsername(appId: string, username: string): Observable<tUser> {

        console.log('Get an user');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'user?username=' + username, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error || 'Server error'));

    }

    generateTemporaryAccessCredentials(appId: string, username: string, directoryId: string): Observable<tTemporaryAccessCredentials> {

        console.log('Get Temporary Access Credentials');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        let tempAccessBody = {
            username: username,
            directoryId: directoryId
        }

        return this.http.post(this.hostUrl + '/tempauth', JSON.stringify(tempAccessBody), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAccountStats(appId: string): Observable<tAccountStats> {

        console.log('Get account statistics for app ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'usersys/appstats', { headers: appIdHeaders })
            .map((res: any) => {
                let accountStats = res.json();
                return accountStats;
            });
    }

    createAccount(newaccount: tAccount): Observable<tAccount> {

        console.log('Create an account');

        let appIdHeaders: Headers = new AppIdHeadersGlow(newaccount.applicationId);

        return this.http.post(this.hostUrl + 'register', JSON.stringify(newaccount), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getLast10AccountLogins(applicationId: string, accountId: string): Observable<tLoginEvent[]> {
        console.log('getLast10AccountLogins');
        let headers: Headers = new AppIdHeadersGlow(applicationId);
        let url: string = this.hostUrl + 'account/' + accountId + '/loginevent';

        return this.http.get(url, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }
    //********************** Organization *************************/


    getOrganization(organizationId: string): Observable<tOrganization> {

        console.log('Get an account');

        let devUserIdHeaders: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'organization/' + organizationId, { headers: devUserIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    //********************** Application *************************/

    getApp(id: string): Observable<tApplication> {

        console.log('Get an application');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'application/' + id, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getApps(): Observable<tApplication[]> {

        console.log('Get applications');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'application', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getInternalUserApplications(): Observable<tApplication[]> {

        console.log('Get getInternalUserApplications');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'internaluser/applications', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    updateApp(application: tApplication): Observable<tApplication> {

        console.log('Update an application');
        // use a Promise in this instance as it is a straight forward single PUT
        let headers: Headers = new AdminHeadersGlow();

        return this.http.put(this.hostUrl + 'application/' + application.applicationId, JSON.stringify(application), { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    createApp(name: string, description: string): Observable<any> {
        console.log('New application');
        console.log('Name: ' + name + ' Description: ' + description);
        let upload = { name, description };

        let headers: Headers = new AdminHeadersGlow();

        return this.http.post(this.hostUrl + 'application', JSON.stringify(upload), { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error || 'create: Server error'));
    }

    deleteApp(application: tApplication): Observable<tApplication> {

        console.log('Delete an application');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AdminHeadersGlow();

        return this.http.delete(this.hostUrl + 'application/' + application.applicationId, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAppKeys(applicationId: string): Observable<ApplicationKey[]> {

        console.log('Get application keys');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'application/' + applicationId + '/apikeys', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    createAppAndKeys(name: string, description: string): Observable<any> {
        console.log('New application');
        console.log('Name: ' + name + ' Description: ' + description);
        let upload = { name, description };

        let headers: Headers = new AdminHeadersGlow();

        return this.http.post(this.hostUrl + 'application', JSON.stringify(upload), { headers: headers })
            .map((res: Response) => res.json())
            .flatMap((newApplication: tApplication) => {
                return this.http
                    .get(this.hostUrl + 'application/' + newApplication.applicationId + '/apikeys', { headers: headers })
                    .map((res: any) => {
                        let appkeys = res.json();
                        newApplication.apikeys = appkeys;
                        return newApplication;
                    })
            })
            .flatMap((newApplication: tApplication) => {
                let dirRequest = { 'applicationId': newApplication.applicationId, 'name': 'default directory', 'description': 'username/password', 'directoryTypeId': '2bb4dcea-7893-4ceb-9d9a-a7f88e57285d', 'status': 'active' };
                let appIdHeaders: Headers = new AppIdHeadersGlow(newApplication.applicationId);
                console.log(JSON.stringify(dirRequest));
                return this.http
                    .post(this.hostUrl + 'directory', JSON.stringify(dirRequest), { headers: appIdHeaders })
                    .map((res: any) => {
                        let directory = res.json();
                        newApplication.directories = directory;
                        return newApplication;
                    });
            })
            .catch((error: any) => Observable.throw(error || 'create: Server error'));
    }

    getAppKey(appKey: string): Observable<ApplicationKey> {

        console.log('Get an application key');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'application/' + appKey, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    createAppKeys(applicationId: string): Observable<any> {
        console.log('New application key');

        let upload = {};

        let headers: Headers = new AdminHeadersGlow();

        return this.http.post(this.hostUrl + 'application/' + applicationId + '/apikeysauto', JSON.stringify(upload), { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    deleteAppKey(applicationId: string, appKey: string): Observable<ApplicationKey> {

        console.log('Delete an application key');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AdminHeadersGlow();

        return this.http.delete(this.hostUrl + 'application/' + applicationId + '/apikey/appKey', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //********************** Directory *************************/

    getDirectories(applicationId: string = null): Observable<tDirectory[]> {

        console.log('Get application directories for ' + applicationId);

        let headers: Headers = null;
        if (applicationId) {
            headers = new AppIdHeadersGlow(applicationId);
        } else {
            headers = new AdminHeadersGlow();

        }
        return this.http.get(this.hostUrl + 'directory/', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDirectoryTypes(applicationId: string): Observable<tDirectoryType[]> {

        console.log('Get application directories for ' + applicationId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);


        return this.http.get(this.hostUrl + 'directorytype', { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //********************** Accounts with Directory Permissions *************************/

    getAccountsOfDirectory(directoryId: string): Observable<tAccount[]> {

        console.log('getAccountsOfDirectory ' + directoryId);

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'account/directory/' + directoryId, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAccountByAccountIdDirectoryPermissions(accountId: string, directoryId: string): Observable<tAccount> {

        console.log('getAccountByDirectoryPermissions ' + accountId);

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'account/' + accountId + '/directory/' + directoryId, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAccountsByUserIdDirectoryPermissions(userId: string, directoryId: string): Observable<tAccount[]> {

        console.log('getAccountsByUserIdDirectoryPermissions ' + userId);

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'user/' + userId + '/directory/' + directoryId, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAccountsByUsernameDirectoryPermissions(username: string, directoryId: string): Observable<tAccount[]> {
        console.log('getAccountsByUsernameDirectoryPermissions ' + username);

        let headers: Headers = new AdminHeadersGlow();

        return this.http.get(this.hostUrl + 'user/directory/' + directoryId + '?username=' + username, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    generateTemporaryAccessCredentialDirectoryPermissions(appId: string, username: string, directoryId: string): Observable<tTemporaryAccessCredentials> {

        console.log('generateTemporaryAccessCredentialDirectoryPermissions');
        let headers: Headers = new AdminHeadersGlow();

        let tempAccessBody = {
            username: username,
            directoryId: directoryId,
            application: {
                applicationId: appId
            }
        }

        return this.http.post(this.hostUrl + 'tempauth/directory', JSON.stringify(tempAccessBody), { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    //********************** Groups *************************/

    createGroup(appId: string, group: tGroup): Observable<tGroup> {

        console.log('Create an group');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.post(this.hostUrl + 'group/', JSON.stringify(group), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getGroups(appId: string): Observable<tGroup[]> {

        console.log('Get Groups ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'group/', { headers: appIdHeaders })
            .map((res: any) => {
                let groups = res.json();
                return groups;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getGroup(appId: string, id: string): Observable<tGroup> {

        console.log('Get an Group');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'group/' + id, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getGroupAccounts(appId: string, id: string): Observable<tGroupAccount[]> {

        console.log('Get accounts of a Group');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'group/' + id + '/accounts', { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    updateGroupAccounts(appId: string, id: string, accounts: {}): Observable<tGroupAccount[]> {

        console.log('update accounts of a Group');

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.put(this.hostUrl + 'group/' + id + '/accounts', JSON.stringify(accounts), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getGroupsOfAccount(appId: string, accountId: string): Observable<tGroupAccount[]> {

        console.log('getGroupsOfAccount ' + accountId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'account/' + accountId + '/group', { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //***********************Functional Groups *************************/

    getFunctionalGroups(appId: string): Observable<tFunctionalGroup[]> {
        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'functionalgroup/', { headers: appIdHeaders })
            .map((res: any) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAccountsInFunctionalGroup(appId: string, functionalGroupId: string): Observable<tFunctionalGroupAccount[]> {
        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'functionalgroup/' + functionalGroupId + '/accounts', { headers: appIdHeaders })
            .map((res: any) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    addAccountToFunctionalGroup(appId: string, body: tFunctionalGroupAccountReq): Observable<any> {
        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .post(this.hostUrl + 'functionalgroupaccount/', { headers: appIdHeaders })
            .map((res: any) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getFunctionalGroupsOfAccount(appId: string, accountId: string): Observable<tFunctionalGroupAccount[]> {

        console.log('getFunctionalGroupsOfAccount ' + accountId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'account/' + accountId + '/functionalgroup', { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }
    //********************** Virtual Entities *************************/

    getVEs(appId: string, userId: string = null): Observable<tVE[]> {

        console.log('Get virtual entities ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);
        if (userId) {
            appIdHeaders.append('userId', userId);
        }

        return this.http
            .get(this.hostUrl + 'virtualentity/', { headers: appIdHeaders })
            .map((res: any) => {
                let VE = res.json();
                return VE;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getVE(appId: string, veId: string, userId: string = null): Observable<tVE> {

        console.log('Get virtual entity ' + veId + ' for app=' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);
        if (userId) {
            appIdHeaders.append('userId', userId);
        }

        let url = this.hostUrl + 'virtualentity/' + veId

        return this.http
            .get(url, { headers: appIdHeaders })
            .map((res: any) => {
                let ve = res.json();
                return ve;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    updateVeResource(appId: string, veId: string, resourceId: string, resourceUpdateBody: any, userId: string = null): Observable<tVE> {

        console.log('Update resource ' + resourceId + ' of virtual entity ' + veId + ' for app=' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);
        if (userId) {
            appIdHeaders.append('userId', userId);
        }

        let url = this.hostUrl + 'virtualentity/' + veId + '/resources/' + resourceId;

        return this.http
            .put(url, resourceUpdateBody, { headers: appIdHeaders })
            .map((res: any) => {
                let ve = res.json();
                return ve;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getVeWithDetailedResources(appId: string, veId: string, userId: string = null): Observable<tVEwithDetailedResources> {

        console.log('Get virtual entity ' + veId + ' for app=' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);
        if (userId) {
            appIdHeaders.append('userId', userId);
        }

        let url = this.hostUrl + 'virtualentity/' + veId + '/resources'

        return this.http
            .get(url, { headers: appIdHeaders })
            .map((res: any) => {
                let ve = res.json();
                return ve;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getVETypes(appId: string): Observable<tVEType[]> {

        console.log('Get virtual entity types ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'vetype/', { headers: appIdHeaders })
            .map((res: any) => {
                let tVE = res.json();
                return tVE;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getVEType(appId: string, veTypeId: string): Observable<tVEType> {

        console.log('Get virtual entity type ' + veTypeId + ' for app=' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'vetype/' + veTypeId, { headers: appIdHeaders })
            .map((res: any) => {
                let ve = res.json();
                return ve;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    //********************** Resources *************************/

    getResources(appId: string): Observable<tResource[]> {

        console.log('Get resources ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'resource/', { headers: appIdHeaders })
            .map((res: any) => {
                let resource = res.json();
                return resource;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getResourceTypes(appId: string): Observable<tResourceType[]> {

        console.log('Get resource types ' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'resourcetype/', { headers: appIdHeaders })
            .map((res: any) => {
                let resourcetype = res.json();
                return resourcetype;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getResourceType(appId: string, resourceTypeId: string): Observable<tResourceType> {

        console.log('Get resource type ' + resourceTypeId + ' for app=' + appId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(appId);

        return this.http
            .get(this.hostUrl + 'resourcetype/' + resourceTypeId, { headers: appIdHeaders })
            .map((res: any) => {
                let resourcetype = res.json();
                return resourcetype;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    //********************** Notifications/Alerts/Templates *************************/

    getTemplates(applicationId: string): Observable<tTemplate[]> {

        console.log('Get templates for ' + applicationId);

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        return this.http.get(this.hostUrl + 'ns/template', { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }



    getTemplatebyProperties(applicationId: string, alertTypeId: string, channelType: string, cultureCode: string): Observable<tTemplate> {

        console.log('Get template for ' + applicationId + alertTypeId + channelType + cultureCode);

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        return this.http.get(this.hostUrl + 'ns/template/' + alertTypeId + '/' + channelType + '/' + cultureCode, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    createTemplate(newtemplate: tTemplate): Observable<tTemplate> {

        console.log('Create a template');

        let appIdHeaders: Headers = new AppIdHeadersGlow(newtemplate.applicationId);

        console.log(JSON.stringify(newtemplate));

        return this.http.post(this.hostUrl + 'ns/template', JSON.stringify(newtemplate), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAlertTypes(appId: string): Observable<tAlertType[]> {

        console.log('Get alert types');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AppIdHeadersGlow(appId);

        return this.http.get(this.hostUrl + 'ns/alerttype', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    getAlertsOfUser(applicationId, userId): Observable<tAlertHistoryUser[]> {
        if (applicationId && userId) {
            console.log('Get alerts of user');
            // use a Promise in this instance as it is a straight forward single GET

            let headers: Headers = new AppIdHeadersGlow(applicationId);

            return this.http.get(this.hostUrl + 'ns/alert/user/' + userId, { headers: headers })
                .map((res: Response) => res.json())
                .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        } else {
            return Observable.throw('no appId/userId')
        }

    };


    sendAlert(alertInfo: any): Observable<tAlertStatus> {

        console.log('Send an alert');
        console.log(alertInfo)
        let appIdHeaders: Headers = new AppIdHeadersGlow(alertInfo.applicationId);
        // let headers: Headers = new AppIdHeadersGlow(appId);

        console.log(JSON.stringify(alertInfo));

        return this.http.post(this.hostUrl + 'ns/alert', JSON.stringify(alertInfo), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //********************** Devices *************************/

    getDeviceTypes(applicationId: string): Observable<tDeviceType[]> {

        console.log('Get device types');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AppIdHeadersGlow(applicationId);

        return this.http.get(this.hostUrl + 'devicetype', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDevices(applicationId: string, userId: string): Observable<tDevice[]> {

        console.log('Get devices');
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AppIdHeadersGlow(applicationId);
        headers.append('userId', userId);
        return this.http.get(this.hostUrl + 'device', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDeviceById(applicationId: string, deviceId: string): Observable<tDevice> {

        console.log('Get device by ID ' + deviceId);
        // use a Promise in this instance as it is a straight forward single GET

        let headers: Headers = new AppIdHeadersGlow(applicationId);
        return this.http.get(this.hostUrl + 'device/' + deviceId, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getProductTypes(applicationId: string): Observable<tProductType[]> {

        console.log('getAssetStatus');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url = this.hostUrl + 'producttype';


        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    discoverDevice(applicationId: string, hardwareId: string): Observable<tDeviceProductDiscovery> {

        console.log('Discover assets and devices');
        console.log(applicationId)
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url = this.hostUrl + 'discover/' + hardwareId;

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDeviceStatus(applicationId: string, hardwareId: string, deviceId: string): Observable<tDeviceStatus> {

        console.log('getDeviceStatus');
        console.log(applicationId)

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url;

        if (hardwareId) {
            url = this.hostUrl + 'device/status?tags=' + hardwareId;
        }
        else {
            url = this.hostUrl + 'device/' + deviceId + '/status';
        }

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDeviceRawPackets(applicationId: string, hardwareId: string, deviceId: string): Observable<tDeviceRawPackets> {

        console.log('Get Raw Packets');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url;
        if (hardwareId) {
            url = this.hostUrl + 'device/rawpackets?tags=' + hardwareId;
        }
        else {
            url = this.hostUrl + 'device/' + deviceId + '/rawpackets';
        }

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDeviceLastReadings(applicationId: string, hardwareId: string, deviceId: string): Observable<tDeviceLastReading> {

        console.log('get Last Readings');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url;
        if (hardwareId) {
            url = this.hostUrl + 'device/lastreadings?tags=' + hardwareId;
        }
        else {
            url = this.hostUrl + 'device/' + deviceId + '/lastreadings';
        }
        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getDeviceSetting(applicationId: string, setting: string, deviceId: string): Observable<tDeviceWithSetting> {

        console.log('Get device ' + deviceId);

        const appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        return this.http
            .get(this.hostUrl + 'device/' + deviceId + '/settings/' + setting, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    setDeviceSetting(applicationId: string, deviceId: string, setting: string, data: any): Observable<tDeviceWithSetting> {

        console.log('get Last Readings');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url = this.hostUrl + 'device/' + deviceId + '/settings/' + setting

        return this.http.post(url, JSON.stringify(data), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //********************** CRM *************************/

    updateCustomerInCrm({ data, applicationId, userId }): Observable<any> {

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        if (userId) {
            appIdHeaders.append('userId', userId);
        }

        return this.http.put(this.hostUrl + '/ticket/customer', JSON.stringify(data), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //********************** Assets *************************/


    getAssetTypes(applicationId: string): Observable<tAssetType[]> {

        console.log('getAssetStatus');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url = this.hostUrl + 'assettype';


        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAssetStatus(applicationId: string, hardwareId: string, assetId: string): Observable<tAssetStatus> {

        console.log('getAssetStatus');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url;

        if (hardwareId) {
            url = this.hostUrl + 'asset/status?tags=' + hardwareId;
        }
        else {
            url = this.hostUrl + 'asset/' + assetId + '/status';
        }

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAsseetRawPackets(applicationId: string, hardwareId: string, assetId: string): Observable<tAssetRawPackets> {

        console.log('Get Raw Packets');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url;
        if (hardwareId) {
            url = this.hostUrl + 'asset/rawpackets?tags=' + hardwareId;
        }
        else {
            url = this.hostUrl + 'asset/' + assetId + '/rawpackets';
        }

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAssetLastReadings(applicationId: string, hardwareId: string, assetId: string): Observable<tDeviceLastReading> {

        console.log('get Last Readings');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url;
        if (hardwareId) {
            url = this.hostUrl + 'asset/lastreadings?tags=' + hardwareId;
        }
        else {
            url = this.hostUrl + 'asset/' + assetId + '/lastreadings';
        }
        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    //July 2019: This is a public call but needs an applicationId on the header. when the scope of the application is a directory we do not have a header. to address this a random guid has been used
    getAccessPointWiFiPassword(applicationId: string = "f4673064-11f3-4cb9-bfb1-f49f87e722cf", mac: string, serialNumber: string): Observable<tWiFiAccessPointInfo> {

        console.log('get Last Readings');

        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url = this.hostUrl + 'wifisetup?MAC=' + mac + "&serialNumber=" + serialNumber;

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    //********************** Device Status Reports *************************/
    getDevicesStatusReportingCapability(applicationId: string = null): Observable<tDeviceCapability> {
        console.log('getDevicesStatusReportingCapability');
        let headers: Headers;
        let url: string = this.hostUrl + 'devices/status/capability';
        if (applicationId) {
            headers = new AppIdHeadersGlow(applicationId);
        } else {
            headers = new AdminHeadersGlow();
            url += '/organization'
        }

        return this.http.get(url, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getDevicesSummaryStatusReport(applicationId: string) {
        console.log('getDevicesSummaryStatusReport');
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url = this.hostUrl + 'devices/status/summary';

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getDevicesStatusReports(applicationId: string, mac: string = null): Observable<tDevicesStatusReport> {
        console.log('getDevicesStatusReports');
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url = this.hostUrl + 'devices/status?';

        if (mac) {
            url += 'mac=' + mac
        }
        console.log(url)
        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }

    getDevicesStatusReportsByState(applicationId: string, state: string, mac: string = null): Observable<tDevicesStatusReportByState> {
        console.log('getDevicesStatusReportsByState');
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        let url = this.hostUrl + 'devices/status/state/' + state;

        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //**********************DCC *************************/
    checkSmetsMpxnIsEligible(data: tEligibitySmetsFuelTypesReq, applicationId: string,): Observable<any> {
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);

        return this.http.post(this.rateLimitingHostUrl + 'eligibility/checksmetsmpxn', JSON.stringify(data), { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    }


    discoverMPXNInventory(applicationId: string, mpan: string): Observable<tMPXNInventory> {
        console.log('Discover MPXN inventory');
        console.log(applicationId, mpan)
        let url = this.hostUrl + 'discover/mpxn/' + mpan + '/inventory';
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    discoverMPXNHealthCheck(applicationId: string, mpan: string): Observable<tStatusIsOk> {
        console.log('Discover MPXN health check');
        let bodyData
        console.log(applicationId)
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url = this.hostUrl + 'discover/mpxn/' + mpan + '/connectivity-health-check';
        return this.http.put(url, {}, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    getDCCInventoryWarnings(applicationId: string, mpan: string): Observable<tMPXNInventoryWithWarnings> {
        console.log('getDCCInventoryWarnings');

        console.log(applicationId)
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        let url = `${this.hostUrl}device/meter-point/${mpan}/inventory/check`;
        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    pollMPXNHealthCheck(applicationId: string, mpan: string): Observable<tMPXNHealthCheck> {
        console.log('poll MPXN health check');
        console.log(applicationId)
        let url = this.hostUrl + 'discover/mpxn/' + mpan + '/connectivity-health-check';
        let appIdHeaders: Headers = new AppIdHeadersGlow(applicationId);
        return this.http.get(url, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    //**********************Traffic & Logs *************************/
    getLogs(id: string): Observable<Log> {

        console.log('Get application logs');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdHeadersGlow(id);
        //let query: string = '{ "sort" : [ { "received_at" : { "order" : "desc" } }], "query": { "match": { "parsedJson.fields.applicationId" : "' + id + '" } } }';

        return this.http.get(this.hostUrl + '/logs/application/search', { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getTrafficTimeSeries(id: string, from: string, to: string, period: string): Observable<tTrafficTimeSeries> {

        console.log('Get traffic as a time series');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdHeadersGlow(id);
        //let query: string = '{ "sort" : [ { "received_at" : { "order" : "desc" } }], "query": { "match": { "parsedJson.fields.applicationId" : "' + id + '" } } }';

        return this.http.get(this.hostUrl + 'logs/application/traffic?from=' + from + '&to=' + to + '&period=' + period, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getTrafficByCountry(id: string, from: string, to: string): Observable<tTrafficTimeSeries> {

        console.log('Get traffic by country');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdHeadersGlow(id);
        //let query: string = '{ "sort" : [ { "received_at" : { "order" : "desc" } }], "query": { "match": { "parsedJson.fields.applicationId" : "' + id + '" } } }';

        return this.http.get(this.hostUrl + +'/logs/application/trafficbycountry?from=' + from + '&to=' + to, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getTrafficBytesAsTimeSeries(id: string, from: string, to: string, period: string): Observable<tTrafficTimeSeries> {

        console.log('Get traffic bytes as a time series');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdHeadersGlow(id);
        //let query: string = '{ "sort" : [ { "received_at" : { "order" : "desc" } }], "query": { "match": { "parsedJson.fields.applicationId" : "' + id + '" } } }';

        return this.http.get(this.hostUrl + '/logs/application/bytes?from=' + from + '&to=' + to + '&period=' + period, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    triggerManualApiDeviceCreated(applicationId: string, userId: string, data): Observable<any> {

        console.log('triggerManualApiDeviceCreated');
        let headers: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);

        return this.http.post(`${this.hostUrl}provision/manual-device-created-event-trigger`, data, { headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    removeAccount(applicationId: string, userId: string): Observable<any> {

        console.log('Get traffic bytes as a time series');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);
        //let query: string = '{ "sort" : [ { "received_at" : { "order" : "desc" } }], "query": { "match": { "parsedJson.fields.applicationId" : "' + id + '" } } }';

        return this.http.delete(`${this.hostUrl}provision/account-removal`, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAppUserOrganizationForUser(applicationId: string, userId: string): Observable<any[]> {
        console.log("Get getAppUserOrganizationDetailsForUser");
        let headers: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);

        return this.http.get(this.hostUrl + "userorganization/user", { headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getAppUserOrganizationUserGroup(applicationId: string, userOrganizationId: string): Observable<any> {
        console.log("Get getAppUserOrganizationUserGroup");
        let headers: Headers = new AppIdHeadersGlow(applicationId);

        return this.http.get(this.hostUrl + "application/userorganization/" + userOrganizationId + "/usergroup", { headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    checkCadOrderEligibility(applicationId: string, userId: string, data: any): Observable<any> {
        console.log('cadOrderEligibility');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);
        return this.http.post(`${this.hostUrl}provision/order-fulfil/glow-cad/eligibility-check`, data, { headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    unallocateCad(data: any): Observable<any> {
        console.log('unallocateCad');
        const { applicationId, userId } = data;
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);
        return this.http.post(`${this.hostUrl}provision/glow-cad/unallocate`, data, { headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    // /api/v0-1/provision/admin/smart-meter/onboard
    dccOnlyOnboard(userId, applicationId, data): Observable<any> {
        // let appIdHeaders: Headers = (applicationId == '10d2d1e6-30ad-4ac9-8350-187c89840ba4' || applicationId == '643864ad-99aa-40ec-b243-2514173bda54') ? new DraxHeaders(data.userId, applicationId) : new HdbHeaders(data.userId, applicationId);
        let appIdHeaders: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);

        return this.http.post(`${this.hostUrl}provision/admin/smart-meter/onboard`, data, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    // /api/v0-1/provision/admin/smart-meter/onboard
    dccOnlyToCad(userId, applicationId, data): Observable<any> {
        // let appIdHeaders: Headers = (applicationId == '10d2d1e6-30ad-4ac9-8350-187c89840ba4' || applicationId == '643864ad-99aa-40ec-b243-2514173bda54') ? new DraxHeaders(data.userId, applicationId) : new HdbHeaders(data.userId, applicationId);
        let appIdHeaders: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);

        return this.http.post(`${this.hostUrl}provision/order-fulfil/glow-cad`, data, { headers: appIdHeaders })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    removeService(applicationId: string, userId: string, veId): Observable<any> {

        console.log('Get traffic bytes as a time series');
        // use a Promise in this instance as it is a straight forward single GET
        let headers: Headers = new AppIdUserIdHeadersGlow(applicationId, userId);
        //let query: string = '{ "sort" : [ { "received_at" : { "order" : "desc" } }], "query": { "match": { "parsedJson.fields.applicationId" : "' + id + '" } } }';

        return this.http.delete(`${this.hostUrl}provision/service-removal/virtual-entity/${veId}`, { headers: headers })
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

}
